export const initialValues = {
  supply: 'O',
  subType: '',
  subTypeDesc: '',
  docType: '',
  transType: '',
  docno: '',
  docdate: '',
  bfpincode: '',
  bfdistrict: '',
  bfcity: '',
  bfstates: '',
  bfAddress: '',
  btpincode: '',
  btdistrict: '',
  btcity: '',
  btstates: '',
  btAddress: '',
  dfPincode: '',
  dfstatecode: '',
  dfstates: '',
  dfDistrict: '',
  dfcity: '',
  dfAddress: '',
  dtPincode: '',
  dtstates: '',
  dtstatecode: '',
  dtdistrict: '',
  dtcity: '',
  dtAddress: '',
  modes: '',
  tObj: {},
  tid: '',
  tname: '',
  tdoc: '',
  vtypes: '',
  vno: '',
  distance: '0',
  tDate: '',
};
export const type = [
  {
    value: 'O',
    label: 'Outward',
  },
  {
    value: 'I',
    label: 'Inward',
  },
];
export const vehicleType = [
  {
    value: 'R',
    label: 'Regular',
  },
  {
    value: 'O',
    label: 'Over Dimensional Cargo',
  },
];
export const mode = [
  {
    value: '1',
    label: 'Road',
  },
  {
    value: '2',
    label: 'Rail',
  },
  {
    value: '3',
    label: 'Air',
  },
  {
    value: '4',
    label: 'Ship',
  },
];

export const outwardSubTypes = [
  { label: 'Supply', value: '1' },
  // { label: "Import", value: "2" },
  { label: 'Export', value: '3' },
  { label: 'Job work', value: '4' },
  { label: 'For own use', value: '5' },
  // { label: "Job work returns", value: "6" },
  // { label: "Sales Return", value: "7" },
  { label: 'Others', value: '8' },
  { label: 'SKD/CKD/Lots', value: '9' },
  { label: 'Line Sales', value: '10' },
  { label: 'Recipient Not Known', value: '11' },
  { label: 'Exhibition or fairs', value: '12' },
];

export const inwardSubTypes = [
  { label: 'Supply', value: '1' },
  { label: 'Import', value: '2' },
  // { label: "Export", value: "3" },
  // { label: "Job work", value: "4" },
  { label: 'For own use', value: '5' },
  { label: 'Job work returns', value: '6' },
  { label: 'Sales Return', value: '7' },
  { label: 'Others', value: '8' },
  { label: 'SKD/CKD/Lots', value: '9' },
  // { label: "Line Sales", value: "10" },
  // { label: "Recipient Not Known", value: "11" },
  { label: 'Exhibition or fairs', value: '12' },
];

const subTypes = [
  { label: 'Supply', value: '1' },
  { label: 'Import', value: '2' },
  { label: 'Export', value: '3' },
  { label: 'Job work', value: '4' },
  { label: 'For own use', value: '5' },
  { label: 'Job work returns', value: '6' },
  { label: 'Sales Return', value: '7' },
  { label: 'Others', value: '8' },
  { label: 'SKD/CKD/Lots', value: '9' },
  { label: 'Line Sales', value: '10' },
  { label: 'Recipient Not Known', value: '11' },
  { label: 'Exhibition or fairs', value: '12' },
];

export const documentTypeOptions = {
  1: [
    { label: 'Tax Invoice', value: 'INV' },
    { label: 'Bill of Supply', value: 'BIL' },
  ],
  2: [{ label: 'Bill of Entry', value: 'BOE' }],
  3: [
    { label: 'Tax Invoice', value: 'INV' },
    { label: 'Bill of Supply', value: 'BIL' },
  ],
  4: [{ label: 'Delivery Challan', value: 'CHL' }],
  9: [
    { label: 'Tax Invoice', value: 'INV' },
    { label: 'Bill of Supply', value: 'BIL' },
    { label: 'Delivery Challan', value: 'CHL' },
  ],
  11: [
    { label: 'Delivery Challan', value: 'CHL' },
    { label: 'Others', value: 'OTH' },
  ],
  5: [{ label: 'Delivery Challan', value: 'CHL' }],
  6: [{ label: 'Delivery Challan', value: 'CHL' }],
  7: [{ label: 'Delivery Challan', value: 'CHL' }],
  12: [{ label: 'Delivery Challan', value: 'CHL' }],
  10: [{ label: 'Delivery Challan', value: 'CHL' }],
  8: [
    { label: 'Delivery Challan', value: 'CHL' },
    { label: 'Others', value: 'OTH' },
  ],
};

export const transTypes = [
  { label: 'Regular', value: '1' },
  { label: 'Bill To-Ship To', value: '2' },
  { label: 'Bill From-Dispatch From', value: '3' },
  { label: 'Combination of 2 & 3', value: '4' },
];

export const docTypes = [
  { label: 'Tax Invoice', value: 'INV' },
  { label: 'Bill of Supply', value: 'BIL' },
  { label: 'Bill of Entry', value: 'BOE' },
  { label: 'Delivery Challan', value: 'CHL' },
  // { label: "Credit Note", value: "CNT" },
  { label: 'Others', value: 'OTH' },
];

export const listEwaySelect = [
  { label: 'My Eway bills', id: 'mewb' },
  { label: 'Others Requested Eway bills', id: 'oewb' },
];

export const database = [
  { label: 'From GST Portal', id: 'gp' },
  { label: 'From Our Database', id: 'od' },
];

export const listEwayHeads = [
  {
    id: 'sl',
    label: 'Sl no',
    width: '30px',
    align: 'left',
  },
  {
    id: 'ewbno',
    label: 'E way Bill no',
    width: '110px',
    align: 'left',
  },
  {
    id: 'cdate',
    label: 'Created Date & Time',
    width: '190px',
    align: 'left',
  },
  {
    id: 'period',
    label: 'Validity Period',
    width: '190px',
    align: 'left',
  },
  {
    id: 'status',
    label: 'Status',
    width: '60px',
    align: 'left',
  },
  {
    id: 'stype',
    label: 'Supply Type',
    width: '75px',
    align: 'left',
  },
  {
    id: 'subtype',
    label: 'Sub Type',
    width: '80px',
    align: 'left',
  },
  {
    id: 'suppliername',
    label: 'Supplier Name',
    width: '150px',
    align: 'left',
  },
  {
    id: 'pgstin',
    label: 'Party GSTIN',
    width: '150px',
    align: 'left',
  },
  {
    id: 'pstate',
    label: 'Party State',
    width: '130px',
    align: 'left',
  },
  {
    id: 'ppincode',
    label: 'Party Pincode',
    width: '80px',
    align: 'left',
  },
  {
    id: 'ttype',
    label: 'Transaction Type',
    width: '160px',
    align: 'left',
  },
  {
    id: 'mot',
    label: 'Mode of Transport',
    width: '70px',
    align: 'left',
  },
  {
    id: 'totItems',
    label: 'Total Items',
    width: '50px',
    align: 'left',
  },
  {
    id: 'transname',
    label: 'Transporter Name',
    width: '150px',
    align: 'left',
  },
  {
    id: 'transid',
    label: 'Tansporter ID',
    width: '130px',
    align: 'left',
  },
  {
    id: 'vechileno',
    label: 'Vehicle Number',
    width: '120px',
    align: 'left',
  },
  {
    id: 'docinvoiceno',
    label: 'Doc/Invoice Number',
    width: '150px',
    align: 'left',
  },
  {
    id: 'docinvoicedate',
    label: 'Doc/Invoice Date',
    width: '150px',
    align: 'left',
  },
  {
    id: 'assvalue',
    label: 'Assessable Value',
    width: '150px',
    align: 'right',
  },
  {
    id: 'tottax',
    label: 'GST + Cess',
    width: '150px',
    align: 'right',
  },
  {
    id: 'totInvvalue',
    label: 'Total Invoice value',
    width: '150px',
    align: 'right',
  },
  {
    id: 'dist',
    label: 'Distance (Kms)',
    width: '50px',
    align: 'right',
  },
];
export const othListEwayHeads = [
  {
    id: 'sl',
    label: 'Sl no',
    width: '20px',
    align: 'left',
  },
  {
    id: 'ewbno',
    label: 'E way Bill no',
    width: '50px',
    align: 'left',
  },
  {
    id: 'cdate',
    label: 'Created Date & Time',
    width: '180px',
    align: 'left',
  },

  {
    id: 'status',
    label: 'Status',
    width: '50px',
    align: 'left',
  },

  {
    id: 'createdBy',
    label: 'Created By',
    width: '100px',
    align: 'left',
  },
  {
    id: 'createdGstin',
    label: 'Created By GSTIN',
    width: '150px',
    align: 'left',
  },
  {
    id: 'docinvoiceno',
    label: 'Doc/Invoice Number',
    width: '150px',
    align: 'left',
  },
  {
    id: 'docinvoicedate',
    label: 'Doc/Invoice Date',
    width: '150px',
    align: 'left',
  },
  {
    id: 'totInvvalue',
    label: 'Total Invoice value',
    width: '150px',
    align: 'left',
  },
  { id: 'action', label: 'Action', width: '100px', align: 'left' },
];
export const validityExtendOptions = [
  { label: 'Natural Calamity', id: 1 },
  { label: 'Law and Order Situation', id: 2 },
  { label: 'Transshipment', id: 4 },
  { label: 'Accident', id: 5 },
  { label: 'Others', id: 99 },
];

export const extendFormInitialData = {
  district: '',
  city: '',
  pincode: '',
  reasoncode: null,
  distance: '',
  remarks: '',
};
export const extendErrFormInitialData = {
  district: '',
  city: '',
  reasoncode: null,
  pincode: '',
  distance: '',
  remarks: '',
};

export const eWayBillColumns = [
  {
    field: 'sl',
    label: 'Sl no',
    width: '60px',
    align: 'left',
    enableSort: false,
  },
  {
    field: 'ewaybillno',
    label: 'E way Bill no',
    width: '130px',
    align: 'left',
    type: 'text',
    inputType: 'number',
    enableSort: true,
  },
  {
    field: 'ewaybilldate',
    label: 'Created Date & Time',
    width: '180px',
    align: 'left',
    type: 'date',
    enableSort: true,
  },
  {
    field: 'validupto',
    label: 'Validity Period',
    width: '150px',
    align: 'left',
    type: 'date',
    enableSort: true,
  },
  {
    field: 'status',
    label: 'Status',
    width: '80px',
    align: 'left',
    type: 'text',
    enableSort: true,
  },
  {
    field: 'supplytype',
    label: 'Supply Type',
    width: '125px',
    align: 'left',
    type: 'select',
    enableSort: true,
    options: [
      { label: 'Outward', value: 'O' },
      { label: 'Inward', value: 'I' },
    ],
  },
  {
    field: 'subtype',
    label: 'Sub Type',
    width: '100px',
    align: 'left',
    type: 'select',
    options: subTypes,
    enableSort: true,
  },
  {
    field: 'fromtradename',
    label: 'From Tade Name',
    width: '150px',
    align: 'left',
    type: 'text',
    enableSort: true,
  },
  {
    field: 'togstin',
    label: 'To GSTIN',
    width: '150px',
    align: 'left',
    type: 'text',
    enableSort: true,
  },
  {
    field: 'billingstate',
    label: 'To State',
    width: '130px',
    align: 'left',
    type: 'text',
    enableSort: true,
    // options: ,
  },
  {
    field: 'billingpincode',
    label: 'To Pincode',
    width: '140px',
    align: 'left',
    type: 'text',
    enableSort: true,
  },
  {
    field: 'transactiontype',
    label: 'Transaction Type',
    width: '160px',
    align: 'left',
    type: 'select',
    options: transTypes,
    enableSort: true,
  },
  {
    field: 'modeoftransport',
    label: 'Mode',
    width: '70px',
    align: 'left',
    type: 'select',
    options: mode,
    enableSort: true,
  },
  {
    field: 'total_items_count',
    label: 'Total Items',
    width: '120px',
    align: 'left',
    type: 'slider',
    enableSort: true,
  },
  {
    field: 'transportername',
    label: 'Transporter Name',
    width: '170px',
    align: 'left',
    type: 'text',
    enableSort: true,
  },
  {
    field: 'transportergstin',
    label: 'Transporter ID',
    width: '130px',
    align: 'left',
    type: 'text',
    enableSort: true,
  },
  {
    field: 'vehicleno',
    label: 'Vehicle Number',
    width: '140px',
    align: 'left',
    type: 'text',
    enableSort: false,
  },
  {
    field: 'invoiceno',
    label: 'Doc/Invoice Number',
    width: '180px',
    align: 'left',
    type: 'text',
    enableSort: true,
  },
  {
    field: 'invoicedate',
    label: 'Doc/Invoice Date',
    width: '150px',
    align: 'left',
    type: 'date',
    enableSort: true,
  },
  {
    field: 'totalitemamount',
    label: 'Assessable Value',
    width: '150px',
    align: 'right',
    type: 'slider',
    enableSort: true,
  },
  {
    field: 'gstamount',
    label: 'GST + Cess',
    width: '150px',
    align: 'right',
    type: 'slider',
    enableSort: true,
  },
  {
    field: 'totalinvoiceamount',
    label: 'Total Invoice value',
    width: '180px',
    align: 'right',
    type: 'slider',
    enableSort: true,
  },
  {
    field: 'distance',
    label: 'Distance (Kms)',
    width: '140px',
    align: 'center',
    type: 'slider',
    enableSort: true,
  },
  // {
  //   field: "status",
  //   label: "Status",
  //   render: (row) => (
  //     <Chip
  //       label={row.status}
  //       color={row.status === "active" ? "success" : "default"}
  //     />
  //   ),
  // },
  // {
  //   field: "actions",
  //   label: "Actions",
  //   render: (row) => <Button onClick={() => handleEdit(row)}>Edit</Button>,
  // },
];

export function checkIfExpired(dateStr) {
  // Convert "30/03/2025 11:59:00 PM" to a Date object
  if (dateStr) {
    const [datePart, timePart, meridian] = dateStr?.split(' ');
    const [day, month, year] = datePart?.split('/');
    // Build a proper ISO string to pass to Date constructor
    const formatted = `${year}-${month}-${day} ${timePart} ${meridian}`;

    const inputDate = new Date(formatted);
    const now = new Date();

    return inputDate < now ? 'Expired' : 'Active';
  } else {
    return '';
  }
}
export function isWithinEightHours(dateStr) {
  // Parse input: "dd/mm/yyyy hh:mm:ss AM/PM"
  if (dateStr) {
    const [datePart, timePart, meridian] = dateStr?.split(' ');
    const [day, month, year] = datePart?.split('/');

    const formatted = `${year}-${month}-${day} ${timePart} ${meridian}`;
    const inputDate = new Date(formatted);

    const now = new Date();

    // 8 hours in milliseconds
    const eightHours = 8 * 60 * 60 * 1000;

    const lowerBound = new Date(now.getTime() - eightHours);
    const upperBound = new Date(now.getTime() + eightHours);

    return inputDate >= lowerBound && inputDate <= upperBound;
  } else {
    return '';
  }
}

export const editPartBReasons = [
  {
    label: 'Due to Break Down',
    value: '1',
  },
  { label: 'Due to Transshipment', value: '2' },
  { label: 'Others(Pls. Specify)', value: '3' },
  {
    label: 'First Time',
    value: '4',
  },
];
